
import * as angular from "angular";

// Scrolling through report fires a lot of 'scroll' events.
// This has an effect on browser performance. This service, used by the reportDisplayer directive,
// prevents these events being called repeatedly by introducing a 'pause' till the next time the scroll event is called.
// This is called a 'debouncer'.
export class ThrottleService {

    static $inject = ["$q", "$timeout"];

    constructor(
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService) {
    }

    // Create a deferred object that will be resolved when we need to actually call the func
    throttle(callback: Function) {

        //return throttled;
        var deferred = this.$q.defer();
        var timeout: angular.IPromise<void>;
        var self = this;
        let requestId = null;

        return function () {
            const context = self, args = arguments;

            const later = (context, args) => () => {

                deferred.resolve(callback.apply(context, args));
                deferred = self.$q.defer();

                // This halves our framerate and further throttles
                //requestAnimationFrame(() => {
                    requestId = null
                //});
            }

            if ((requestId === null) || (requestId === undefined)) {
                requestId = requestAnimationFrame(later(this, args));
            }

            return deferred.promise;
        };
    }
}
